import { eUSAState } from '../../../ui-toolkit/enums/states';
import { eTitleFees } from '../../../ui-toolkit/enums/eTitleFees';
import { ISelectOption } from '../../../ui-toolkit';

const defaultFeesOptions = {
  'Title - Abstract and Exam': eTitleFees.abstract_and_exam,
  'Title - Acris': eTitleFees.acris,
  'Title - Attorney': eTitleFees.attorney,
  'Title - Closer': eTitleFees.closer,
  'Title - Closing': eTitleFees.closing,
  'Title - Commitment': eTitleFees.commitment,
  'Title - Co-ordination': eTitleFees.coordination,
  'Title - CPL Borrower': eTitleFees.cpl_borrower,
  'Title - CPL Buyer': eTitleFees.cpl_buyer,
  'Title - CPL Lender': eTitleFees.cpl_lender,
  'Title - CPL Seller': eTitleFees.cpl_seller,
  'Title - Document Copies': eTitleFees.document_copies,
  'Title - Document Preparation': eTitleFees.document_preparation,
  'Title - Exam': eTitleFees.exam,
  'Title - Escrow': eTitleFees.escrow,
  'Title - Extended Lenders Policy': eTitleFees.extended_lenders_policy,
  'Title - Hold Open': eTitleFees.hold_open,
  "Title - Lender's Policy Guaranty Fee": eTitleFees.lenders_policy_guaranty,
  "Title - Owner's Policy Guaranty Fee": eTitleFees.owners_policy_guaranty,
  'Title - Title Closing': eTitleFees.title_closing,
  'Title - Title Opinion': eTitleFees.title_opinion,
  'Title - HOI Endorsement': eTitleFees.hoi_endorsement,
  'Title - Homeowners Policy': eTitleFees.homeowners_policy,
  'Title - Lenders Policy': eTitleFees.lenders_policy,
  'Title - Municipal Lien Certification': eTitleFees.municipal_lien_certification,
  'Title - Recording Processing': eTitleFees.recording_processing,
  'Title - Search': eTitleFees.search,
  'Title - Search Report': eTitleFees.search_report,
  'Title - Settlement': eTitleFees.settlement,
  'Title - Standard Owners Policy': eTitleFees.standard_owners_policy,
  'Title - Sub Escrow': eTitleFees.sub_escrow,
  'Title - Survey': eTitleFees.survey,
  'Title - Tax Certification': eTitleFees.tax_certification,
  'Title - TIEFF Lenders Policy': eTitleFees.tieff_lenders_policy,
  'Title - TIEFF Owners Policy': eTitleFees.tieff_owners_policy,
  'Title - Updated Search': eTitleFees.updated_search,
  'Title - Updated Tax Certification': eTitleFees.updated_tax_certification,
  'Title - State Policy Fee - Lenders': eTitleFees.lenders_state_policy,
  'Title - State Policy Fee - Owners': eTitleFees.owners_state_policy,
};

export default function generateTitleFeesOptions(state?: eUSAState): ISelectOption<eTitleFees>[] {
  const defaultFees = Object.entries(defaultFeesOptions).map((entry) => ({ label: entry[0], value: entry[1] }));
  if (!state) return defaultFees;

  if (state === eUSAState.OK) {
    const okFees = [...defaultFees];
    const replaceItemIndex = okFees.findIndex((fee) => fee.value === eTitleFees.exam);
    okFees.splice(replaceItemIndex, 1);
    return okFees;
  } else if (state === eUSAState.NC) {
    const ncFee = { label: 'Title - Attorney Document Review', value: eTitleFees.attorney_document_review };
    return [ncFee, ...defaultFees];
  } else if (state === eUSAState.IA) {
    const iaFees = [
      { label: 'Title - Lenders Title Guaranty', value: eTitleFees.lenders_title_guaranty },
      { label: 'Title - Owners Title Guaranty', value: eTitleFees.owners_title_guaranty },
    ];
    return [...iaFees, ...defaultFees];
  } else {
    return defaultFees;
  }
}
